/*
 * Clim & Chill — Gift With Purchase (Phase A, panier)
 * Ajoute/retire automatiquement des mini-ventilos OFFERTS (0 €) selon le
 * sous-total ELIGIBLE (hors lignes cadeau). 1 offert par tranche de threshold.
 * Sélecteur de couleur + barre de progression dans le drawer et la page panier.
 *
 * Config injectée dans layout/theme.liquid : window.CC_GWP = {
 *   threshold, giftProductId, variants:{Blanc,Noir,Vert}, defaultColor, optOut
 * }
 */
(function () {
  'use strict';

  var CFG = window.CC_GWP;
  if (!CFG || !CFG.giftProductId || !CFG.variants) return;

  var THRESHOLD = CFG.threshold || 30000;
  var GIFT_ID = Number(CFG.giftProductId);
  var VARIANTS = {}; // { Blanc: 5429..., Noir:..., Vert:... }
  Object.keys(CFG.variants).forEach(function (c) {
    VARIANTS[c] = Number(CFG.variants[c]);
  });
  var COLORS = Object.keys(VARIANTS);
  var DEFAULT_COLOR = CFG.defaultColor && VARIANTS[CFG.defaultColor] ? CFG.defaultColor : COLORS[0];
  var LS_KEY = 'cc-gwp-color';
  var GIFT_VARIANT_IDS = COLORS.map(function (c) { return VARIANTS[c]; });

  var origFetch = window.fetch.bind(window);
  var reconciling = false;
  var pending = false;
  var scheduleTimer = null;

  /* ------------------------------------------------------------------ */
  /* Couleur choisie (persistée)                                         */
  /* ------------------------------------------------------------------ */
  function getColor() {
    var c;
    try { c = localStorage.getItem(LS_KEY); } catch (e) {}
    return c && VARIANTS[c] ? c : DEFAULT_COLOR;
  }
  function setColor(c) {
    if (!VARIANTS[c]) return;
    try { localStorage.setItem(LS_KEY, c); } catch (e) {}
  }

  /* Opt-out persistant : la PDP peut refuser le cadeau via sessionStorage.
     Priorité au sessionStorage ('1' = refusé), sinon valeur Liquid CFG.optOut. */
  function isOptOut() {
    try {
      if (sessionStorage.getItem('cc-gwp-optout') === '1') return true;
    } catch (e) {}
    return !!CFG.optOut;
  }

  /* ------------------------------------------------------------------ */
  /* Données panier                                                      */
  /* ------------------------------------------------------------------ */
  function getCart() {
    return origFetch(window.routes.cart_url + '.js', {
      headers: { 'Accept': 'application/json', 'X-CC-GWP': '1' }
    }).then(function (r) { return r.json(); });
  }

  function eligibleSubtotal(cart) {
    return (cart.items || []).reduce(function (sum, it) {
      return it.product_id === GIFT_ID ? sum : sum + it.final_line_price;
    }, 0);
  }

  function currentGiftQty(cart) {
    var map = {};
    (cart.items || []).forEach(function (it) {
      if (it.product_id === GIFT_ID) map[it.variant_id] = (map[it.variant_id] || 0) + it.quantity;
    });
    return map;
  }

  function computeTarget(cart) {
    var eligible = eligibleSubtotal(cart);
    var earned = isOptOut() ? 0 : Math.floor(eligible / THRESHOLD);
    var color = getColor();
    var chosen = VARIANTS[color];
    var updates = {};
    GIFT_VARIANT_IDS.forEach(function (vid) {
      updates[vid] = vid === chosen ? earned : 0;
    });
    return { eligible: eligible, earned: earned, color: color, updates: updates };
  }

  function needsUpdate(cart, target) {
    var cur = currentGiftQty(cart);
    for (var i = 0; i < GIFT_VARIANT_IDS.length; i++) {
      var vid = GIFT_VARIANT_IDS[i];
      if ((target.updates[vid] || 0) !== (cur[vid] || 0)) return true;
    }
    return false;
  }

  /* ------------------------------------------------------------------ */
  /* Re-render Dawn (sections)                                           */
  /* ------------------------------------------------------------------ */
  function collectSections() {
    var list = [];
    if (document.querySelector('cart-drawer')) list.push('cart-drawer');
    if (document.getElementById('cart-icon-bubble')) list.push('cart-icon-bubble');
    var mi = document.getElementById('main-cart-items');
    if (mi && mi.dataset.id) list.push(mi.dataset.id);
    var mf = document.getElementById('main-cart-footer');
    if (mf && mf.dataset.id) list.push(mf.dataset.id);
    return list;
  }

  function internalUpdate(updates, sections) {
    var body = {
      updates: updates,
      sections: sections,
      sections_url: window.location.pathname
    };
    return origFetch(window.routes.cart_update_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-CC-GWP': '1'
      },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function parseHTML(str) {
    return new DOMParser().parseFromString(str, 'text/html');
  }

  function applySections(cartJson) {
    var sections = cartJson.sections || {};
    var itemCount = cartJson.item_count;

    var drawer = document.querySelector('cart-drawer');
    if (drawer && sections['cart-drawer']) {
      var dHtml = parseHTML(sections['cart-drawer']);
      ['cart-drawer-items', '.cart-drawer__footer'].forEach(function (sel) {
        var target = document.querySelector(sel);
        var source = dHtml.querySelector(sel);
        if (target && source) target.replaceWith(source);
      });
      drawer.classList.toggle('is-empty', itemCount === 0);
    }

    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      var bHtml = parseHTML(sections['cart-icon-bubble']);
      var bSrc = bHtml.querySelector('.shopify-section') || bHtml.body.firstElementChild;
      if (bSrc) bubble.innerHTML = bSrc.innerHTML;
    }

    ['main-cart-items', 'main-cart-footer'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el || !el.dataset.id || !sections[el.dataset.id]) return;
      var html = parseHTML(sections[el.dataset.id]);
      var src = html.querySelector('.js-contents');
      var tgt = el.querySelector('.js-contents');
      if (src && tgt) tgt.innerHTML = src.innerHTML;
      el.classList.toggle('is-empty', itemCount === 0);
    });
  }

  /* ------------------------------------------------------------------ */
  /* Boucle de réconciliation                                            */
  /* ------------------------------------------------------------------ */
  function reconcile() {
    if (reconciling) { pending = true; return Promise.resolve(); }
    reconciling = true;
    return getCart()
      .then(function (cart) {
        renderWidgets(cart);
        tagGiftLines();
        var target = computeTarget(cart);
        if (!needsUpdate(cart, target)) return null;
        var sections = collectSections();
        return internalUpdate(target.updates, sections).then(function (res) {
          if (res && res.sections) applySections(res);
          // Re-render du widget avec les données à jour
          return getCart().then(function (cart2) {
            renderWidgets(cart2);
            tagGiftLines();
          });
        });
      })
      .catch(function (e) { console.warn('[cc-gwp]', e); })
      .then(function () {
        reconciling = false;
        if (pending) { pending = false; return reconcile(); }
      });
  }

  function scheduleReconcile() {
    clearTimeout(scheduleTimer);
    scheduleTimer = setTimeout(reconcile, 120);
  }

  /* ------------------------------------------------------------------ */
  /* Interception des mutations panier                                   */
  /* ------------------------------------------------------------------ */
  function isInternal(init) {
    if (!init || !init.headers) return false;
    var h = init.headers;
    if (typeof h.get === 'function') return !!h.get('X-CC-GWP');
    return !!(h['X-CC-GWP'] || h['x-cc-gwp']);
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch(input, init);
    try {
      if (!isInternal(init) && /\/cart\/(add|change|update|clear)/.test(url)) {
        p.then(function () { scheduleReconcile(); }, function () {});
      }
    } catch (e) {}
    return p;
  };

  /* ------------------------------------------------------------------ */
  /* Rendu UI (barre + sélecteur couleur)                                */
  /* ------------------------------------------------------------------ */
  function money(cents) {
    var v = (cents / 100).toFixed(2).replace('.', ',');
    return v.replace(/,00$/, '') + ' €';
  }

  function colorSwatchesHTML(active) {
    return COLORS.map(function (c) {
      var cls = 'cc-gwp__swatch cc-gwp__swatch--' + c.toLowerCase();
      if (c === active) cls += ' is-active';
      return (
        '<button type="button" class="' + cls + '" data-cc-color="' + c + '"' +
        ' aria-label="Couleur ' + c + '" aria-pressed="' + (c === active) + '" title="' + c + '">' +
        '<span class="cc-gwp__swatch-dot"></span></button>'
      );
    }).join('');
  }

  function widgetHTML(cart) {
    if (!cart || cart.item_count === 0) return '';
    var eligible = eligibleSubtotal(cart);
    var earned = isOptOut() ? 0 : Math.floor(eligible / THRESHOLD);
    var remainder = eligible % THRESHOLD;
    var toNext = THRESHOLD - remainder;
    var html = '<div class="cc-gwp__box">';

    if (earned === 0) {
      var pct0 = Math.min(100, Math.round((eligible / THRESHOLD) * 100));
      html += '<p class="cc-gwp__msg">Plus que <strong>' + money(toNext) +
        '</strong> pour un mini ventilo offert 🎁</p>';
      html += '<div class="cc-gwp__bar"><span class="cc-gwp__fill" style="width:' + pct0 + '%"></span></div>';
    } else {
      var plural = earned > 1 ? 's' : '';
      html += '<p class="cc-gwp__msg cc-gwp__msg--won">🎁 ' + earned +
        ' mini ventilo' + plural + ' offert' + plural + ' !</p>';
      if (remainder > 0) {
        var pct1 = Math.min(100, Math.round((remainder / THRESHOLD) * 100));
        html += '<p class="cc-gwp__msg cc-gwp__msg--next">Plus que <strong>' + money(toNext) +
          '</strong> pour un ventilo de plus</p>';
        html += '<div class="cc-gwp__bar"><span class="cc-gwp__fill" style="width:' + pct1 + '%"></span></div>';
      }
      html += '<div class="cc-gwp__picker">' +
        '<span class="cc-gwp__picker-label">Couleur du cadeau&nbsp;:</span>' +
        '<div class="cc-gwp__swatches">' + colorSwatchesHTML(getColor()) + '</div>' +
        '</div>';
    }

    html += '</div>';
    return html;
  }

  function renderWidgets(cart) {
    var html = widgetHTML(cart);
    var nodes = document.querySelectorAll('[data-cc-gwp-drawer], [data-cc-gwp-page]');
    nodes.forEach(function (n) {
      n.innerHTML = html;
      n.classList.toggle('cc-gwp--empty', !html);
    });
  }

  function tagGiftLines() {
    document.querySelectorAll('.cart-item').forEach(function (row) {
      var input = row.querySelector('[data-quantity-variant-id]');
      var vid = input ? Number(input.dataset.quantityVariantId) : null;
      if (vid && GIFT_VARIANT_IDS.indexOf(vid) !== -1) {
        row.classList.add('cc-gift-line');
        var nameEl = row.querySelector('.cart-item__name');
        if (nameEl && !row.querySelector('.cc-gift-badge')) {
          var b = document.createElement('span');
          b.className = 'cc-gift-badge';
          b.textContent = 'Offert 🎁';
          nameEl.parentNode.insertBefore(b, nameEl.nextSibling);
        }
      }
    });
  }

  /* Sélection de couleur (délégation) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-cc-color]') : null;
    if (!btn) return;
    e.preventDefault();
    var c = btn.getAttribute('data-cc-color');
    if (c === getColor()) return;
    setColor(c);
    // Retour visuel immédiat
    document.querySelectorAll('[data-cc-color]').forEach(function (b) {
      var on = b.getAttribute('data-cc-color') === c;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on);
    });
    scheduleReconcile();
  });

  /* ------------------------------------------------------------------ */
  /* Init                                                                */
  /* ------------------------------------------------------------------ */
  /* La PDP (Phase B) déclenche une réconciliation après avoir changé
     l'opt-out / la couleur, via un événement global. */
  document.addEventListener('cc-gwp:refresh', function () { scheduleReconcile(); });

  function init() { reconcile(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
